// src/components/VerificaEmail.js
// Fascia in alto finché l'email di chi è collegato non è confermata (utils/verificaEmail.js):
// viola con i giorni rimasti, rossa dopo il termine (si consulta ma non si modifica).
// «Rimanda l'email» la rispedisce; «Ho confermato» ricontrolla subito (si ricontrolla anche
// da solo quando si torna sulla scheda dopo aver aperto il link).
import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useToast } from "../utils/Toast";
import { statoVerificaEmail } from "../utils/verificaEmail";

export default function VerificaEmail() {
  const { currentUser, organization, isPlatformOwner, emailVerificata, aggiornaVerificaEmail, rimandaVerificaEmail } = useAuth();
  const { addToast } = useToast();
  const [occupato, setOccupato] = useState("");
  if (!currentUser || currentUser.isAnonymous || isPlatformOwner) return null;
  const s = statoVerificaEmail({ org: organization, emailVerificata });
  if (!s.richiesta) return null;

  const rimanda = async () => {
    setOccupato("rimanda");
    try {
      const r = await rimandaVerificaEmail();
      addToast(r?.giaVerificata ? "La tua email risulta già confermata." : `Email inviata a ${currentUser.email}: apri il link «Conferma la mia email».`, "success", 8000);
    } catch (e) {
      addToast(e?.message && !/internal/i.test(e.message) ? e.message : "Invio non riuscito: riprova tra qualche minuto.", "error");
    }
    setOccupato("");
  };
  const controlla = async () => {
    setOccupato("controlla");
    const ok = await aggiornaVerificaEmail();
    addToast(ok ? "Email confermata, grazie!" : "Non risulta ancora confermata: apri il link nell'email (guarda anche nello spam).", ok ? "success" : "info", 8000);
    setOccupato("");
  };

  const giorni = s.giorniRimasti === 1 ? "1 giorno" : `${s.giorniRimasti} giorni`;
  const st = s.bloccata
    ? { bg: "#fef2f2", bordo: "#fecaca", col: "#991b1b", testo: `Conferma la tua email (${currentUser.email}) per continuare a lavorare: fino ad allora i dati si possono consultare ma non modificare.` }
    : { bg: "#f5f3ff", bordo: "#ddd6fe", col: "#5b21b6", testo: `Conferma la tua email (${currentUser.email}) con il link che ti abbiamo mandato: serve per invitare i colleghi e, entro ${giorni}, per continuare a inserire dati.` };
  const bottone = { border: "none", borderRadius: 7, padding: "5px 12px", fontSize: 12, fontWeight: 700, cursor: "pointer" };
  return (
    <div data-test="verifica-email" style={{ background: st.bg, borderBottom: `1px solid ${st.bordo}`, color: st.col, padding: "7px 16px", fontSize: 12.5, fontWeight: 600, display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
      <span style={{ flex: 1, minWidth: 220 }}>📧 {st.testo}</span>
      <button onClick={rimanda} disabled={!!occupato} style={{ ...bottone, background: "#fff", color: st.col, border: `1px solid ${st.bordo}` }}>{occupato === "rimanda" ? "Invio…" : "Rimanda l'email"}</button>
      <button onClick={controlla} disabled={!!occupato} style={{ ...bottone, background: "#7c3aed", color: "#fff" }}>{occupato === "controlla" ? "Controllo…" : "Ho confermato"}</button>
    </div>
  );
}
